import React from 'react';

import { isNil } from 'lodash';

import DocumentContentIcon from '~/core/iconComponents/icons/documents/DocumentContentIcon';
import DocumentTranslatedIcon from '~/core/iconComponents/icons/documents/DocumentTranslatedIcon';
import { FileLinkButtonProps } from '~/core/molecules/FileLinkButton/types';
import cn from '~/utils/cn';

const FileLinkButton: React.FC<FileLinkButtonProps> = ({ originalFile, translatedFile, className = '' }) => {
  if (isNil(originalFile) && isNil(translatedFile)) return null;

  return (
    <div
      className={cn(
        'group bg-gradient-4 inline-flex items-center gap-0 rounded-full bg-cover px-8 py-4 duration-200 hover:shadow-md focus:bg-auto',
        className
      )}
    >
      {originalFile ? (
        <a href={originalFile.url} target="_blank" rel="noreferrer" title="View Document">
          <DocumentContentIcon size={24} />
        </a>
      ) : null}

      {translatedFile ? (
        <a href={translatedFile.url} target="_blank" rel="noreferrer" title="View Translation">
          <DocumentTranslatedIcon size={24} />
        </a>
      ) : null}
    </div>
  );
};

export default FileLinkButton;
